@if (personas && recentlyReviewed) {
  <div class="reviewers-container">
    <mat-drawer-container class="min-height-600 min-width-600">
      <mat-drawer-content class="margin-16 padding-right-16">
        <div class="d-flex justify-content-between align-items-center">
          <h1>Reviewers</h1>
          <button mat-raised-button color="primary" class="review-document-button" (click)="openMultiSelectReviewDialog()">
            <mat-icon>upload_file</mat-icon>
            Review Document
          </button>
        </div>
        <div #personasGrid>
          <mat-grid-list cols="{{ cols }}" rowHeight="1:1" gutterSize="8" class="reviewers">
            @for (persona of personaFilteredOptions | async; track persona.id) {
              <mat-grid-tile>
                <mat-card appearance="outlined" class="" [attr.data-test-id]="'reviewers-persona-card-' + persona.name">
                  <mat-card-title>{{ strings.textOverflow(persona.name, 50) }}</mat-card-title>
                  <mat-card-content>{{ strings.textOverflow(persona.summary, 100) }}</mat-card-content>
                </mat-card>
              </mat-grid-tile>
            }
          </mat-grid-list>
        </div>
      </mat-drawer-content>
      <mat-drawer mode="side" opened position="end">
        <div>
          <button mat-button class="filter-button" (click)="openFilterDialog()">
            <mat-icon>list</mat-icon>
            <span>Filters ({{ filterCount }})</span>
          </button>
          <mat-form-field appearance="outline" color="accent" class="search-field margin-top-16">
            <mat-icon matSuffix>search</mat-icon>
            <input
              matInput
              matTooltip="Filter Reviewers"
              placeholder="Search Reviewers"
              [formControl]="searchFormController"
              [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of personaFilteredOptions | async; track option.id) {
                <mat-option [value]="option.name">{{ option.name }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <div class="d-flex padding-bottom-16 width-300">
            <p>Recently Reviewed Documents</p>
            <button mat-icon-button (click)="getRecentlyReviewed()" matTooltip="Refresh list">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
          <div class="recently-reviewed">
            @for (doc of filteredRecentlyReviewed; track doc.review_id; let i = $index) {
              <div class="padding-bottom-16">
                <span
                  class="doc-line"
                  [matTooltip]="failedTooltipText"
                  [matTooltipDisabled]="doc.status !== 'FAILED'"
                  matTooltipClass="failed-tooltip"
                  matTooltipPosition="right"
                  matTooltipShowDelay="150">
                  <a
                    mat-button
                    [disabled]="doc.status === 'IN-PROGRESS' || doc.status === 'FAILED'"
                    [routerLink]="'/reviewers/details/' + doc.review_id"
                    class="text_underline"
                    [attr.data-test-id]="'reviewers-recently-reviewed-link-' + i"
                    >{{ strings.textOverflow(doc.document, 30) }}</a
                  >
                </span>

                <br />
                <div class="d-flex">
                  @if (doc.status === 'IN-PROGRESS') {
                    <p class="margin-left-8 font-subscript">
                      {{ strings.textOverflow('By ' + findPersonaNames(doc.persona_id) + ', Processing...', 40) }}
                    </p>
                  } @else if (doc.status === 'FAILED') {
                    <p class="margin-left-8 font-subscript">
                      {{ strings.textOverflow('By ' + findPersonaNames(doc.persona_id) + ', FAILED', 40) }}
                    </p>
                  } @else {
                    <p class="margin-left-8 font-subscript">
                      {{
                        strings.textOverflow(
                          'By ' + findPersonaNames(doc.persona_id) + ', On ' + formatDate(doc.created_at),
                          40
                        )
                      }}
                    </p>
                  }
                  <!-- <button mat-icon-button [disabled]="doc.status === 'IN-PROGRESS'" class="small-icon">
                  <mat-icon color="tertiary">delete</mat-icon>
                </button> -->
                </div>
                @if (doc.status === 'IN-PROGRESS') {
                  <mat-progress-bar
                    mode="determinate"
                    value="{{ true ? 30 : 100 }}"
                    class="margin-left-8"
                    style="width: 200px"></mat-progress-bar>
                } @else if (doc.status === 'FAILED') {
                  <mat-progress-bar
                    color="warn"
                    mode="determinate"
                    value="{{ true ? 30 : 100 }}"
                    class="margin-left-8"
                    style="width: 200px"></mat-progress-bar>
                } @else {
                  <mat-divider />
                }
              </div>
            }
          </div>
        </div>
      </mat-drawer>
    </mat-drawer-container>
  </div>
}
